import React, { memo, useMemo } from 'react';
import { FaExclamation } from 'react-icons/fa';
import { LiaComment } from 'react-icons/lia';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { formatPrice } from '../../../utils/formatter';
import Button from '../../shared/buttons/Button';
import Row from '../../shared/table/Row';
import SelectableRow from '../../shared/table/SelectableRow';
import Table from '../../shared/table/Table';

const VisitPartsTable = ({ visitParts, loading, onVisitPartClick, onVisitPartDeleteClick, readOnly }) => {
  const isTabletView = useSelector((state) => state.screen.isTabletView);
  const tableRows = useMemo(
    () =>
      visitParts.map((visitPart, i) => (
        <SelectableRow key={i} onClick={() => onVisitPartClick(visitPart)}>
          <Row>
            <div className="flex gap-1 items-center">
              {visitPart.comment && <LiaComment size={20} className="text-contrast1" />}
              {visitPart.isCritical && <FaExclamation size={14} className="text-contrast1" />}
              {visitPart.part.name}
            </div>
          </Row>
          {!isTabletView && <Row children={formatPrice(visitPart.partPrice)} />}
          <Row children={formatPrice(visitPart.count)} />
          <Row children={formatPrice(visitPart.price)} />
          {!readOnly && (
            <Row
              children={
                <div title="Видалити" className="w-full text-end z-10">
                  <Button
                    onClick={(event) => {
                      event.stopPropagation();
                      onVisitPartDeleteClick(visitPart);
                    }}
                    variant="secondary2"
                    disabled={loading}
                  >
                    <MdOutlineDeleteOutline size={20} />
                  </Button>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [isTabletView, readOnly, onVisitPartDeleteClick, loading, visitParts, onVisitPartClick],
  );
  return (
    <Table
      columns={isTabletView ? mobileColumns(readOnly) : columns(readOnly)}
      data={tableRows}
      onRowClick={() => ({})}
    />
  );
};

function mobileColumns(readOnly) {
  if (readOnly) {
    return [
      { name: 'Назва', className: 'w-[70%]' },
      { name: 'од', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
    ];
  } else {
    return [
      { name: 'Назва', className: 'w-[65%]' },
      { name: 'од', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
      { name: 'Дії', className: 'w-[5%] text-center' },
    ];
  }
}

function columns(readOnly) {
  if (readOnly) {
    return [
      { name: 'Назва', className: 'w-[70%]' },
      { name: 'Ціна за од', className: 'w-[15%]' },
      { name: 'Кількість', className: 'w-[15%]' },
      { name: 'Ціна', className: 'w-[15%]' },
    ];
  } else {
    return [
      { name: 'Назва', className: 'w-[60%]' },
      { name: 'Ціна за од', className: 'w-[15%]' },
      { name: 'Кількість', className: 'w-[10%]' },
      { name: 'Ціна', className: 'w-[10%]' },
      { name: 'Дії', className: 'w-[5%] text-center' },
    ];
  }
}

export default memo(VisitPartsTable);
